// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.MuiList-root .listItem {
  border-right: 4px solid transparent;
  color: #aeb7be;
  padding-top: 6px;
  padding-bottom: 6px;
  min-height: 36px;
}

.MuiListItemText-root {
  color: #333;
}

.listItem:hover,
.listItem.active {
  color: rgb(22.2114285714, 24.7742857143, 67.4885714286);
  border-color: rgb(22.2114285714, 24.7742857143, 67.4885714286);
}
.listItem:hover .MuiListItemText-root,
.listItem:hover .MuiListItemIcon-root,
.listItem.active .MuiListItemText-root,
.listItem.active .MuiListItemIcon-root {
  color: inherit;
}

.nav-section-label {
  list-style: none;
  padding: 12px 16px 4px;
  margin: 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #8a94a6;
  line-height: 1.2;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}
.nav-section-label .MuiSvgIcon-root {
  font-size: 16px;
  color: inherit;
}

.nav-section-label:first-child {
  padding-top: 8px;
}

.nav-tree-group {
  position: relative;
}

.nav-nested-list {
  position: relative;
  margin: 0;
  padding: 0 0 2px;
}

.listItem--nested {
  position: relative;
  padding-left: 38px !important;
  padding-right: 4px !important;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.listItem--nested .MuiListItemIcon-root {
  position: relative;
  flex-shrink: 0;
  min-width: 20px !important;
  /* join dot */
}
.listItem--nested .MuiListItemIcon-root::before {
  content: "";
  position: absolute;
  left: -15px;
  top: 50%;
  width: 5px;
  height: 5px;
  margin-top: -2.5px;
  border-radius: 50%;
  background: #aeb7be;
  pointer-events: none;
  z-index: 1;
}
.listItem--nested .MuiListItemText-root {
  flex: 1 1 auto;
  min-width: 0;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-left: 8px !important;
}
.listItem--nested {
  /* vertical segment for this row (top → center) */
}
.listItem--nested::before {
  content: "";
  position: absolute;
  left: 24px;
  top: 0;
  height: 50%;
  border-left: 1.5px dotted #aeb7be;
  pointer-events: none;
}
.listItem--nested {
  /* horizontal branch + vertical below mid (unless last) */
}
.listItem--nested::after {
  content: "";
  position: absolute;
  left: 24px;
  top: 50%;
  width: 14px;
  height: 50%;
  border-left: 1.5px dotted #aeb7be;
  border-top: 1.5px dotted #aeb7be;
  pointer-events: none;
  box-sizing: border-box;
}
.listItem--nested.listItem--nested-last::after {
  height: 0;
  border-left: none;
}
.listItem--nested {
  /* path parent → active child: vertical active */
}
.listItem--nested.listItem--nested-path::before {
  border-left: 2px dotted rgb(22.2114285714, 24.7742857143, 67.4885714286);
}
.listItem--nested.listItem--nested-path:not(.listItem--nested-active)::after {
  border-left: 2px dotted rgb(22.2114285714, 24.7742857143, 67.4885714286);
}
.listItem--nested {
  /* active child: branch + dot active; line below stays gray */
}
.listItem--nested.listItem--nested-active::before {
  border-left: 2px dotted rgb(22.2114285714, 24.7742857143, 67.4885714286);
}
.listItem--nested.listItem--nested-active::after {
  border-top: 2px dotted rgb(22.2114285714, 24.7742857143, 67.4885714286);
  border-left: 1.5px dotted #aeb7be;
}
.listItem--nested.listItem--nested-active.listItem--nested-last::after {
  border-left: none;
}
.listItem--nested.listItem--nested-active .MuiListItemIcon-root::before {
  background: rgb(22.2114285714, 24.7742857143, 67.4885714286);
}`, "",{"version":3,"sources":["webpack://./src/wrapper/MainSideBar/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EAEE,mCAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAAF;;AAEA;EACE,WAAA;AACF;;AACA;;EAEE,uDCkBQ;EDjBR,8DCiBQ;ADfV;AADE;;;;EAEI,cAAA;AAKN;;AADA;EACE,gBAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAIF;AAFE;EACE,eAAA;EACA,cAAA;AAIJ;;AAAA;EACE,gBAAA;AAGF;;AAAA;EACE,kBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,6BAAA;EACA,6BAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;AAGF;AADE;EACE,kBAAA;EACA,cAAA;EACA,0BAAA;EAEA,aAAA;AAEJ;AADI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;AAGN;AACE;EACE,cAAA;EACA,YAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;AACJ;AAnCA;EAqCE,iDAAA;AACF;AAAE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,WAAA;EACA,iCAAA;EACA,oBAAA;AAEJ;AA/CA;EAgDE,yDAAA;AAEF;AADE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,iCAAA;EACA,gCAAA;EACA,oBAAA;EACA,sBAAA;AAGJ;AAAE;EACE,SAAA;EACA,iBAAA;AAEJ;AAlEA;EAmEE,gDAAA;AAEF;AADE;EACE,wEAAA;AAGJ;AAAE;EACE,wEAAA;AAEJ;AA3EA;EA4EE,6DAAA;AAEF;AADE;EACE,wEAAA;AAGJ;AAAE;EACE,uEAAA;EACA,iCAAA;AAEJ;AACE;EACE,iBAAA;AACJ;AAEE;EACE,4DCtHM;ADsHV","sourcesContent":["@import \"./../../assets/variables\";\n.MuiList-root\n.listItem {\n  border-right: 4px solid transparent;\n  color: #aeb7be;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  min-height: 36px;\n}\n.MuiListItemText-root {\n  color: #333;\n}\n.listItem:hover,\n.listItem.active {\n  color: $hoverBg;\n  border-color: $hoverBg;\n  .MuiListItemText-root,\n  .MuiListItemIcon-root {\n      color: inherit;\n  }\n}\n\n.nav-section-label {\n  list-style: none;\n  padding: 12px 16px 4px;\n  margin: 0;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #8a94a6;\n  line-height: 1.2;\n  user-select: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n\n  .MuiSvgIcon-root {\n    font-size: 16px;\n    color: inherit;\n  }\n}\n\n.nav-section-label:first-child {\n  padding-top: 8px;\n}\n\n.nav-tree-group {\n  position: relative;\n}\n\n.nav-nested-list {\n  position: relative;\n  margin: 0;\n  padding: 0 0 2px;\n}\n\n.listItem--nested {\n  position: relative;\n  padding-left: 38px !important;\n  padding-right: 4px !important;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n\n  .MuiListItemIcon-root {\n    position: relative;\n    flex-shrink: 0;\n    min-width: 20px !important;\n\n    /* join dot */\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: -15px;\n      top: 50%;\n      width: 5px;\n      height: 5px;\n      margin-top: -2.5px;\n      border-radius: 50%;\n      background: #aeb7be;\n      pointer-events: none;\n      z-index: 1;\n    }\n  }\n\n  .MuiListItemText-root {\n    flex: 1 1 auto;\n    min-width: 0;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n    padding-left: 8px !important;\n  }\n\n  /* vertical segment for this row (top → center) */\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 24px;\n    top: 0;\n    height: 50%;\n    border-left: 1.5px dotted #aeb7be;\n    pointer-events: none;\n  }\n\n  /* horizontal branch + vertical below mid (unless last) */\n  &::after {\n    content: \"\";\n    position: absolute;\n    left: 24px;\n    top: 50%;\n    width: 14px;\n    height: 50%;\n    border-left: 1.5px dotted #aeb7be;\n    border-top: 1.5px dotted #aeb7be;\n    pointer-events: none;\n    box-sizing: border-box;\n  }\n\n  &.listItem--nested-last::after {\n    height: 0;\n    border-left: none;\n  }\n\n  /* path parent → active child: vertical active */\n  &.listItem--nested-path::before {\n    border-left: 2px dotted $hoverBg;\n  }\n\n  &.listItem--nested-path:not(.listItem--nested-active)::after {\n    border-left: 2px dotted $hoverBg;\n  }\n\n  /* active child: branch + dot active; line below stays gray */\n  &.listItem--nested-active::before {\n    border-left: 2px dotted $hoverBg;\n  }\n\n  &.listItem--nested-active::after {\n    border-top: 2px dotted $hoverBg;\n    border-left: 1.5px dotted #aeb7be;\n  }\n\n  &.listItem--nested-active.listItem--nested-last::after {\n    border-left: none;\n  }\n\n  &.listItem--nested-active .MuiListItemIcon-root::before {\n    background: $hoverBg;\n  }\n}\n","@import 'functions';\n@import 'mixins';\n$themeColor: #1a1d4f;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import 'bs_variables';\n\n// Layouts\n$sidebarWidth: 285px;\n$headerHeight: 46px;\n$footerHeight: 27px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n// Header\n\n$borderColor: darken(white, 10%);\n$linkColor: #666;\n$hoverBg: darken($themeColor, 3%);\n$hoverColor: #fff;\n$hoverBorderColor: darken($themeColor, 10%);\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #fff;\n$blue: #012d55;\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #f3f3f3;\n$lightGrey: #999;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n$danger: $redColor;\n$warning: $yellowColor;\n$success: $greenColor;\n\n// Sidebar\n$sidebarBackground: #fff;\n$sidebarzIndex: 8;\n$sidebarHeadBg: #f9f9f9;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #eee;\n$sidebarRowColor: $darkGrey;\n\n// Footer\n\n$footerBackground: $themeColor;\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n$baseFontFamily: 'Open Sans', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
